import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useBusinessesUIContext } from "../BusinessesUIContext";
import * as actions from "../../../_redux/businesses/businessesActions";

export function BusinessesGrouping() {
  const dispatch = useDispatch();
  const [approving, setApproving] = useState(false);

  // Businesses UI Context
  const businessesUIContext = useBusinessesUIContext();
  const businessesUIProps = useMemo(() => {
    return {
      ids: businessesUIContext.ids,
      setIds: businessesUIContext.setIds,
      queryParams: businessesUIContext.queryParams,
      openDeleteBusinessesDialog: businessesUIContext.openDeleteBusinessesDialog,
      openFetchBusinessesDialog: businessesUIContext.openFetchBusinessesDialog,
      openUpdateBusinessesStatusDialog:
        businessesUIContext.openUpdateBusinessesStatusDialog,
    };
  }, [businessesUIContext]);

  const handleBulkApprove = () => {
    if (businessesUIProps.ids.length === 0) return;
    if (!window.confirm(`Are you sure you want to approve ${businessesUIProps.ids.length} selected businesses?`)) {
      return;
    }
    setApproving(true);
    dispatch(actions.updateBusinessesStatus(businessesUIProps.ids, 0, "", false))
      .then(() => {
        dispatch(actions.fetchBusinesses(businessesUIProps.queryParams)).then(() => {
          businessesUIProps.setIds([]);
          setApproving(false);
        });
      })
      .catch((err) => {
        setApproving(false);
        alert("Failed to bulk approve: " + (err?.message || "Unknown error"));
      });
  };

  return (
    <div className="form mb-4">
      <div className="card card-custom bg-light border-0 py-3 px-6 d-flex flex-row align-items-center justify-content-between flex-wrap shadow-xs">
        <div className="d-flex align-items-center my-1 mr-4" style={{ gap: "10px" }}>
          <span className="font-weight-bolder font-size-sm" style={{ color: "#181C32", marginRight: "8px" }}>
            Selected Businesses:
          </span>
          <span
            className="label label-primary label-inline font-weight-bolder font-size-sm py-2 px-3"
            style={{ backgroundColor: "#3699FF", color: "#ffffff", minWidth: "36px", textAlign: "center", borderRadius: "6px" }}
          >
            {businessesUIProps.ids.length}
          </span>
        </div>
        <div className="d-flex align-items-center my-1" style={{ gap: "8px" }}>
          <button
            type="button"
            className="btn btn-success font-weight-bolder font-size-sm shadow-xs"
            disabled={approving}
            onClick={handleBulkApprove}
            title="Approve all selected businesses immediately"
          >
            {approving ? (
              <>
                <i className="fa fa-circle-notch fa-spin mr-1"></i> Approving...
              </>
            ) : (
              <>
                <i className="fa fa-check-circle mr-1"></i> Bulk Approve
              </>
            )}
          </button>
          <button
            type="button"
            className="btn btn-light-primary font-weight-bolder font-size-sm"
            onClick={businessesUIProps.openUpdateBusinessesStatusDialog}
          >
            <i className="fa fa-sync-alt mr-1"></i> Update Status
          </button>
        </div>
      </div>
    </div>
  );
}

